import styled from '@emotion/styled';

import { breakpoints } from 'styles/basic';

interface AlbumPhotoProps {
  sorce?: string | undefined;
}

const Wrapper = styled.div`
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: .3rem solid ${(props) => props.theme.color.lightGray};
`;

const AlbumsWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 -2rem;
  padding: 0;
  list-style: none;

  @media (min-width: ${breakpoints.laptop}) {
    justify-content: unset;
  }
`;

const AlbumItem = styled.li`
  width: 24rem;
  padding: 2rem;
`;

const AlbumName = styled.h1`
  margin-top: 1rem;
  margin-bottom: 0;
  font-size: 1.6rem;
  color: ${(props) => props.theme.mainColors.trinary};
`;

const AlbumDate = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  color: ${(props) => props.theme.colorGray.secondary};

  span {
    font-size: 1.2rem;
  }
  img {
    width: 2rem;
    height: auto;
    margin-left: auto;
    border: .1rem solid ${(props) => props.theme.color.gray};
  }
`;

const AlbumPhoto = styled.div<AlbumPhotoProps>`
  display: block;
  width: 20rem;
  height: 20rem;
  margin-bottom: 1rem;
  border: .1rem solid ${(props) => props.theme.color.gray};
  border-radius: .5rem;
  background: ${(props) => `url(${props.sorce}) center center no-repeat` || props.theme.color.lightGray};
  background-size: contain;
`;

export {
  Wrapper,
  AlbumsWrapper,
  AlbumItem,
  AlbumName,
  AlbumDate,
  AlbumPhoto
};
